const n = {
  ad: "Andorra",
  ae: "De Forenede Arabiske Emirater",
  af: "Afghanistan",
  ag: "Antigua og Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikansk Samoa",
  at: "Østrig",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Aserbajdsjan",
  ba: "Bosnien-Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "De tidligere Nederlandske Antiller",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Hviderusland",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocosøerne",
  cd: "Congo-Kinshasa",
  cf: "Den Centralafrikanske Republik",
  cg: "Congo-Brazzaville",
  ch: "Schweiz",
  ci: "Elfenbenskysten",
  ck: "Cookøerne",
  cl: "Chile",
  cm: "Cameroun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Juleøen",
  cy: "Cypern",
  cz: "Tjekkiet",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Den Dominikanske Republik",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Vestsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsøerne",
  fm: "Mikronesien",
  fo: "Færøerne",
  fr: "Frankrig",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Fransk Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grønland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ækvatorialguinea",
  gr: "Grækenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "SAR Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Det Britiske Territorium i Det Indiske Ocean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgisistan",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comorerne",
  kn: "Saint Kitts og Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanøerne",
  kz: "Kasakhstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxembourg",
  lv: "Letland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Marshalløerne",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "SAR Macao",
  mp: "Nordmarianerne",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverne",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Ny Kaledonien",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Holland",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Fransk Polynesien",
  pg: "Papua Ny Guinea",
  ph: "Filippinerne",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint Pierre og Miquelon",
  pr: "Puerto Rico",
  ps: "De palæstinensiske områder",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumænien",
  rs: "Serbien",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saudi-Arabien",
  sb: "Salomonøerne",
  sc: "Seychellerne",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenien",
  sj: "Svalbard og Jan Mayen",
  sk: "Slovakiet",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé og Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- og Caicosøerne",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadsjikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Tyrkiet",
  tt: "Trinidad og Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstaten",
  vc: "Saint Vincent og Grenadinerne",
  ve: "Venezuela",
  vg: "De Britiske Jomfruøer",
  vi: "De Amerikanske Jomfruøer",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis og Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, e = {
  selectedCountryAriaLabel: "Valgt land",
  noCountrySelected: "Intet land er valgt",
  countryListAriaLabel: "Liste over lande",
  searchPlaceholder: "Søg",
  zeroSearchResults: "Ingen resultater fundet",
  oneSearchResult: "1 resultat fundet",
  multipleSearchResults: "${count} resultater fundet",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, i = { ...n, ...e }, r = {
  ad: "Andorra",
  ae: "Vereinigte Arabische Emirate",
  af: "Afghanistan",
  ag: "Antigua und Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentinien",
  as: "Amerikanisch-Samoa",
  at: "Österreich",
  au: "Australien",
  aw: "Aruba",
  ax: "Ålandinseln",
  az: "Aserbaidschan",
  ba: "Bosnien und Herzegowina",
  bb: "Barbados",
  bd: "Bangladesch",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei Darussalam",
  bo: "Bolivien",
  bq: "Bonaire, Sint Eustatius und Saba",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botsuana",
  by: "Belarus",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosinseln",
  cd: "Kongo-Kinshasa",
  cf: "Zentralafrikanische Republik",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cookinseln",
  cl: "Chile",
  cm: "Kamerun",
  cn: "China",
  co: "Kolumbien",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Weihnachtsinsel",
  cy: "Zypern",
  cz: "Tschechien",
  de: "Deutschland",
  dj: "Dschibuti",
  dk: "Dänemark",
  dm: "Dominica",
  do: "Dominikanische Republik",
  dz: "Algerien",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Ägypten",
  eh: "Westsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Äthiopien",
  fi: "Finnland",
  fj: "Fidschi",
  fk: "Falklandinseln",
  fm: "Mikronesien",
  fo: "Färöer",
  fr: "Frankreich",
  ga: "Gabun",
  gb: "Vereinigtes Königreich",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Französisch-Guayana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Äquatorialguinea",
  gr: "Griechenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Sonderverwaltungsregion Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungarn",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Britisches Territorium im Indischen Ozean",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaika",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgisistan",
  kh: "Kambodscha",
  ki: "Kiribati",
  km: "Komoren",
  kn: "St. Kitts und Nevis",
  kp: "Nordkorea",
  kr: "Südkorea",
  kw: "Kuwait",
  ky: "Kaimaninseln",
  kz: "Kasachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marokko",
  mc: "Monaco",
  md: "Republik Moldau",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagaskar",
  mh: "Marshallinseln",
  mk: "Nordmazedonien",
  ml: "Mali",
  mm: "Myanmar",
  mn: "Mongolei",
  mo: "Sonderverwaltungsregion Macau",
  mp: "Nördliche Marianen",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Malediven",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Mosambik",
  na: "Namibia",
  nc: "Neukaledonien",
  ne: "Niger",
  nf: "Norfolkinsel",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Niederlande",
  no: "Norwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Neuseeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Französisch-Polynesien",
  pg: "Papua-Neuguinea",
  ph: "Philippinen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "St. Pierre und Miquelon",
  pr: "Puerto Rico",
  ps: "Palästinensische Autonomiegebiete",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Russland",
  rw: "Ruanda",
  sa: "Saudi-Arabien",
  sb: "Salomonen",
  sc: "Seychellen",
  sd: "Sudan",
  se: "Schweden",
  sg: "Singapur",
  sh: "St. Helena",
  si: "Slowenien",
  sj: "Spitzbergen und Jan Mayen",
  sk: "Slowakei",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Südsudan",
  st: "São Tomé und Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Eswatini",
  tc: "Turks- und Caicosinseln",
  td: "Tschad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadschikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunesien",
  to: "Tonga",
  tr: "Türkei",
  tt: "Trinidad und Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tansania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "Vereinigte Staaten",
  uy: "Uruguay",
  uz: "Usbekistan",
  va: "Vatikanstadt",
  vc: "St. Vincent und die Grenadinen",
  ve: "Venezuela",
  vg: "Britische Jungferninseln",
  vi: "Amerikanische Jungferninseln",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis und Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Südafrika",
  zm: "Sambia",
  zw: "Simbabwe"
}, o = {
  selectedCountryAriaLabel: "Ausgewähltes Land",
  noCountrySelected: "Kein Land ausgewählt",
  countryListAriaLabel: "Liste der Länder",
  searchPlaceholder: "Suchen",
  zeroSearchResults: "Keine Suchergebnisse",
  oneSearchResult: "1 Suchergebnis",
  multipleSearchResults: "${count} Suchergebnisse",
  // additional countries (not supported by country-list library)
  ac: "Ascension-Insel",
  xk: "Kosovo"
}, s = { ...r, ...o }, t = {
  ad: "Andorra",
  ae: "United Arab Emirates",
  af: "Afghanistan",
  ag: "Antigua & Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "American Samoa",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Åland Islands",
  az: "Azerbaijan",
  ba: "Bosnia & Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgium",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "St. Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribbean Netherlands",
  br: "Brazil",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocos (Keeling) Islands",
  cd: "Congo - Kinshasa",
  cf: "Central African Republic",
  cg: "Congo - Brazzaville",
  ch: "Switzerland",
  ci: "Côte d’Ivoire",
  ck: "Cook Islands",
  cl: "Chile",
  cm: "Cameroon",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cape Verde",
  cw: "Curaçao",
  cx: "Christmas Island",
  cy: "Cyprus",
  cz: "Czechia",
  de: "Germany",
  dj: "Djibouti",
  dk: "Denmark",
  dm: "Dominica",
  do: "Dominican Republic",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egypt",
  eh: "Western Sahara",
  er: "Eritrea",
  es: "Spain",
  et: "Ethiopia",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falkland Islands",
  fm: "Micronesia",
  fo: "Faroe Islands",
  fr: "France",
  ga: "Gabon",
  gb: "United Kingdom",
  gd: "Grenada",
  ge: "Georgia",
  gf: "French Guiana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Greenland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Equatorial Guinea",
  gr: "Greece",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hong Kong SAR China",
  hn: "Honduras",
  hr: "Croatia",
  ht: "Haiti",
  hu: "Hungary",
  id: "Indonesia",
  ie: "Ireland",
  il: "Israel",
  im: "Isle of Man",
  in: "India",
  io: "British Indian Ocean Territory",
  iq: "Iraq",
  ir: "Iran",
  is: "Iceland",
  it: "Italy",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kyrgyzstan",
  kh: "Cambodia",
  ki: "Kiribati",
  km: "Comoros",
  kn: "St. Kitts & Nevis",
  kp: "North Korea",
  kr: "South Korea",
  kw: "Kuwait",
  ky: "Cayman Islands",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Lebanon",
  lc: "St. Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lithuania",
  lu: "Luxembourg",
  lv: "Latvia",
  ly: "Libya",
  ma: "Morocco",
  mc: "Monaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "St. Martin",
  mg: "Madagascar",
  mh: "Marshall Islands",
  mk: "North Macedonia",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongolia",
  mo: "Macao SAR China",
  mp: "Northern Mariana Islands",
  mq: "Martinique",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexico",
  my: "Malaysia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "New Caledonia",
  ne: "Niger",
  nf: "Norfolk Island",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Netherlands",
  no: "Norway",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "New Zealand",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "French Polynesia",
  pg: "Papua New Guinea",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Poland",
  pm: "St. Pierre & Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinian Territories",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Rwanda",
  sa: "Saudi Arabia",
  sb: "Solomon Islands",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Sweden",
  sg: "Singapore",
  sh: "St. Helena",
  si: "Slovenia",
  sj: "Svalbard & Jan Mayen",
  sk: "Slovakia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "South Sudan",
  st: "São Tomé & Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syria",
  sz: "Eswatini",
  tc: "Turks & Caicos Islands",
  td: "Chad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tajikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turkey",
  tt: "Trinidad & Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraine",
  ug: "Uganda",
  us: "United States",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatican City",
  vc: "St. Vincent & Grenadines",
  ve: "Venezuela",
  vg: "British Virgin Islands",
  vi: "U.S. Virgin Islands",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis & Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "South Africa",
  zm: "Zambia",
  zw: "Zimbabwe"
}, l = {
  selectedCountryAriaLabel: "Change country, selected ${countryName} (${dialCode})",
  noCountrySelected: "Select country",
  countryListAriaLabel: "List of countries",
  searchPlaceholder: "Search",
  clearSearchAriaLabel: "Clear search",
  zeroSearchResults: "No results found",
  oneSearchResult: "1 result found",
  multipleSearchResults: "${count} results found",
  // additional countries (not supported by country-list library)
  ac: "Ascension Island",
  xk: "Kosovo"
}, u = { ...t, ...l }, d = {
  ad: "Andorra",
  ae: "Emiratos Árabes Unidos",
  af: "Afganistán",
  ag: "Antigua y Barbuda",
  ai: "Anguila",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Islas Åland",
  az: "Azerbaiyán",
  ba: "Bosnia y Herzegovina",
  bb: "Barbados",
  bd: "Bangladés",
  be: "Bélgica",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Baréin",
  bi: "Burundi",
  bj: "Benín",
  bl: "San Bartolomé",
  bm: "Bermudas",
  bn: "Brunéi",
  bo: "Bolivia",
  bq: "Caribe neerlandés",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Bután",
  bw: "Botsuana",
  by: "Bielorrusia",
  bz: "Belice",
  ca: "Canadá",
  cc: "Islas Cocos",
  cd: "República Democrática del Congo",
  cf: "República Centroafricana",
  cg: "Congo",
  ch: "Suiza",
  ci: "Côte d’Ivoire",
  ck: "Islas Cook",
  cl: "Chile",
  cm: "Camerún",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curazao",
  cx: "Isla de Navidad",
  cy: "Chipre",
  cz: "Chequia",
  de: "Alemania",
  dj: "Yibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argelia",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egipto",
  eh: "Sáhara Occidental",
  er: "Eritrea",
  es: "España",
  et: "Etiopía",
  fi: "Finlandia",
  fj: "Fiyi",
  fk: "Islas Malvinas",
  fm: "Micronesia",
  fo: "Islas Feroe",
  fr: "Francia",
  ga: "Gabón",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Georgia",
  gf: "Guayana Francesa",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupe",
  gq: "Guinea Ecuatorial",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bisáu",
  gy: "Guyana",
  hk: "RAE de Hong Kong (China)",
  hn: "Honduras",
  hr: "Croacia",
  ht: "Haití",
  hu: "Hungría",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israel",
  im: "Isla de Man",
  in: "India",
  io: "Territorio Británico del Océano Índico",
  iq: "Irak",
  ir: "Irán",
  is: "Islandia",
  it: "Italia",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordania",
  jp: "Japón",
  ke: "Kenia",
  kg: "Kirguistán",
  kh: "Camboya",
  ki: "Kiribati",
  km: "Comoras",
  kn: "San Cristóbal y Nieves",
  kp: "Corea del Norte",
  kr: "Corea del Sur",
  kw: "Kuwait",
  ky: "Islas Caimán",
  kz: "Kazajistán",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lucía",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesoto",
  lt: "Lituania",
  lu: "Luxemburgo",
  lv: "Letonia",
  ly: "Libia",
  ma: "Marruecos",
  mc: "Mónaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "San Martín",
  mg: "Madagascar",
  mh: "Islas Marshall",
  mk: "Macedonia del Norte",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAE de Macao (China)",
  mp: "Islas Marianas del Norte",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricio",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malasia",
  mz: "Mozambique",
  na: "Namibia",
  nc: "Nueva Caledonia",
  ne: "Níger",
  nf: "Isla Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Países Bajos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nueva Zelanda",
  om: "Omán",
  pa: "Panamá",
  pe: "Perú",
  pf: "Polinesia Francesa",
  pg: "Papúa Nueva Guinea",
  ph: "Filipinas",
  pk: "Pakistán",
  pl: "Polonia",
  pm: "San Pedro y Miquelón",
  pr: "Puerto Rico",
  ps: "Territorios Palestinos",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Catar",
  re: "Reunión",
  ro: "Rumanía",
  rs: "Serbia",
  ru: "Rusia",
  rw: "Ruanda",
  sa: "Arabia Saudí",
  sb: "Islas Salomón",
  sc: "Seychelles",
  sd: "Sudán",
  se: "Suecia",
  sg: "Singapur",
  sh: "Santa Elena",
  si: "Eslovenia",
  sj: "Svalbard y Jan Mayen",
  sk: "Eslovaquia",
  sl: "Sierra Leona",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sudán del Sur",
  st: "Santo Tomé y Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Esuatini",
  tc: "Islas Turcas y Caicos",
  td: "Chad",
  tg: "Togo",
  th: "Tailandia",
  tj: "Tayikistán",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistán",
  tn: "Túnez",
  to: "Tonga",
  tr: "Turquía",
  tt: "Trinidad y Tobago",
  tv: "Tuvalu",
  tw: "Taiwán",
  tz: "Tanzania",
  ua: "Ucrania",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguay",
  uz: "Uzbekistán",
  va: "Ciudad del Vaticano",
  vc: "San Vicente y las Granadinas",
  ve: "Venezuela",
  vg: "Islas Vírgenes Británicas",
  vi: "Islas Vírgenes de EE. UU.",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis y Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudáfrica",
  zm: "Zambia",
  zw: "Zimbabue"
}, c = {
  selectedCountryAriaLabel: "País seleccionado",
  noCountrySelected: "Ningún país seleccionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Buscar",
  zeroSearchResults: "No se han encontrado resultados",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "isla Ascencion",
  xk: "Kosovo"
}, m = { ...d, ...c }, g = {
  ad: "Andorre",
  ae: "Émirats arabes unis",
  af: "Afghanistan",
  ag: "Antigua-et-Barbuda",
  ai: "Anguilla",
  al: "Albanie",
  am: "Arménie",
  ao: "Angola",
  ar: "Argentine",
  as: "Samoa américaines",
  at: "Autriche",
  au: "Australie",
  aw: "Aruba",
  ax: "Îles Åland",
  az: "Azerbaïdjan",
  ba: "Bosnie-Herzégovine",
  bb: "Barbade",
  bd: "Bangladesh",
  be: "Belgique",
  bf: "Burkina Faso",
  bg: "Bulgarie",
  bh: "Bahreïn",
  bi: "Burundi",
  bj: "Bénin",
  bl: "Saint-Barthélemy",
  bm: "Bermudes",
  bn: "Brunéi Darussalam",
  bo: "Bolivie",
  bq: "Pays-Bas caribéens",
  br: "Brésil",
  bs: "Bahamas",
  bt: "Bhoutan",
  bw: "Botswana",
  by: "Biélorussie",
  bz: "Belize",
  ca: "Canada",
  cc: "Îles Cocos",
  cd: "Congo-Kinshasa",
  cf: "République centrafricaine",
  cg: "Congo-Brazzaville",
  ch: "Suisse",
  ci: "Côte d’Ivoire",
  ck: "Îles Cook",
  cl: "Chili",
  cm: "Cameroun",
  cn: "Chine",
  co: "Colombie",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cap-Vert",
  cw: "Curaçao",
  cx: "Île Christmas",
  cy: "Chypre",
  cz: "Tchéquie",
  de: "Allemagne",
  dj: "Djibouti",
  dk: "Danemark",
  dm: "Dominique",
  do: "République dominicaine",
  dz: "Algérie",
  ec: "Équateur",
  ee: "Estonie",
  eg: "Égypte",
  eh: "Sahara occidental",
  er: "Érythrée",
  es: "Espagne",
  et: "Éthiopie",
  fi: "Finlande",
  fj: "Fidji",
  fk: "Îles Malouines",
  fm: "États fédérés de Micronésie",
  fo: "Îles Féroé",
  fr: "France",
  ga: "Gabon",
  gb: "Royaume-Uni",
  gd: "Grenade",
  ge: "Géorgie",
  gf: "Guyane française",
  gg: "Guernesey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambie",
  gn: "Guinée",
  gp: "Guadeloupe",
  gq: "Guinée équatoriale",
  gr: "Grèce",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinée-Bissau",
  gy: "Guyana",
  hk: "R.A.S. chinoise de Hong Kong",
  hn: "Honduras",
  hr: "Croatie",
  ht: "Haïti",
  hu: "Hongrie",
  id: "Indonésie",
  ie: "Irlande",
  il: "Israël",
  im: "Île de Man",
  in: "Inde",
  io: "Territoire britannique de l’océan Indien",
  iq: "Irak",
  ir: "Iran",
  is: "Islande",
  it: "Italie",
  je: "Jersey",
  jm: "Jamaïque",
  jo: "Jordanie",
  jp: "Japon",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambodge",
  ki: "Kiribati",
  km: "Comores",
  kn: "Saint-Christophe-et-Niévès",
  kp: "Corée du Nord",
  kr: "Corée du Sud",
  kw: "Koweït",
  ky: "Îles Caïmans",
  kz: "Kazakhstan",
  la: "Laos",
  lb: "Liban",
  lc: "Sainte-Lucie",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesotho",
  lt: "Lituanie",
  lu: "Luxembourg",
  lv: "Lettonie",
  ly: "Libye",
  ma: "Maroc",
  mc: "Monaco",
  md: "Moldavie",
  me: "Monténégro",
  mf: "Saint-Martin",
  mg: "Madagascar",
  mh: "Îles Marshall",
  mk: "Macédoine du Nord",
  ml: "Mali",
  mm: "Myanmar (Birmanie)",
  mn: "Mongolie",
  mo: "R.A.S. chinoise de Macao",
  mp: "Îles Mariannes du Nord",
  mq: "Martinique",
  mr: "Mauritanie",
  ms: "Montserrat",
  mt: "Malte",
  mu: "Maurice",
  mv: "Maldives",
  mw: "Malawi",
  mx: "Mexique",
  my: "Malaisie",
  mz: "Mozambique",
  na: "Namibie",
  nc: "Nouvelle-Calédonie",
  ne: "Niger",
  nf: "Île Norfolk",
  ng: "Nigéria",
  ni: "Nicaragua",
  nl: "Pays-Bas",
  no: "Norvège",
  np: "Népal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nouvelle-Zélande",
  om: "Oman",
  pa: "Panama",
  pe: "Pérou",
  pf: "Polynésie française",
  pg: "Papouasie-Nouvelle-Guinée",
  ph: "Philippines",
  pk: "Pakistan",
  pl: "Pologne",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Porto Rico",
  ps: "Territoires palestiniens",
  pt: "Portugal",
  pw: "Palaos",
  py: "Paraguay",
  qa: "Qatar",
  re: "La Réunion",
  ro: "Roumanie",
  rs: "Serbie",
  ru: "Russie",
  rw: "Rwanda",
  sa: "Arabie saoudite",
  sb: "Îles Salomon",
  sc: "Seychelles",
  sd: "Soudan",
  se: "Suède",
  sg: "Singapour",
  sh: "Sainte-Hélène",
  si: "Slovénie",
  sj: "Svalbard et Jan Mayen",
  sk: "Slovaquie",
  sl: "Sierra Leone",
  sm: "Saint-Marin",
  sn: "Sénégal",
  so: "Somalie",
  sr: "Suriname",
  ss: "Soudan du Sud",
  st: "Sao Tomé-et-Principe",
  sv: "Salvador",
  sx: "Saint-Martin (partie néerlandaise)",
  sy: "Syrie",
  sz: "Eswatini",
  tc: "Îles Turques-et-Caïques",
  td: "Tchad",
  tg: "Togo",
  th: "Thaïlande",
  tj: "Tadjikistan",
  tk: "Tokelau",
  tl: "Timor oriental",
  tm: "Turkménistan",
  tn: "Tunisie",
  to: "Tonga",
  tr: "Turquie",
  tt: "Trinité-et-Tobago",
  tv: "Tuvalu",
  tw: "Taïwan",
  tz: "Tanzanie",
  ua: "Ukraine",
  ug: "Ouganda",
  us: "États-Unis",
  uy: "Uruguay",
  uz: "Ouzbékistan",
  va: "État de la Cité du Vatican",
  vc: "Saint-Vincent-et-les-Grenadines",
  ve: "Venezuela",
  vg: "Îles Vierges britanniques",
  vi: "Îles Vierges des États-Unis",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis-et-Futuna",
  ws: "Samoa",
  ye: "Yémen",
  yt: "Mayotte",
  za: "Afrique du Sud",
  zm: "Zambie",
  zw: "Zimbabwe"
}, b = {
  selectedCountryAriaLabel: "Pays sélectionné",
  noCountrySelected: "Aucun pays sélectionné",
  countryListAriaLabel: "Liste des pays",
  searchPlaceholder: "Recherche",
  zeroSearchResults: "Aucun résultat trouvé",
  oneSearchResult: "1 résultat trouvé",
  multipleSearchResults: "${count} résultats trouvés",
  // additional countries (not supported by country-list library)
  ac: "Île de l'Ascension",
  xk: "Kosovo"
}, k = { ...g, ...b }, h = {
  ad: "Andora",
  ae: "Ujedinjeni Arapski Emirati",
  af: "Afganistan",
  ag: "Antigva i Barbuda",
  ai: "Angvila",
  al: "Albanija",
  am: "Armenija",
  ao: "Angola",
  ar: "Argentina",
  as: "Američka Samoa",
  at: "Austrija",
  au: "Australija",
  aw: "Aruba",
  ax: "Ålandski otoci",
  az: "Azerbajdžan",
  ba: "Bosna i Hercegovina",
  bb: "Barbados",
  bd: "Bangladeš",
  be: "Belgija",
  bf: "Burkina Faso",
  bg: "Bugarska",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint Barthélemy",
  bm: "Bermudi",
  bn: "Brunej",
  bo: "Bolivija",
  bq: "Karipski otoci Nizozemske",
  br: "Brazil",
  bs: "Bahami",
  bt: "Butan",
  bw: "Bocvana",
  by: "Bjelorusija",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosovi (Keelingovi) otoci",
  cd: "Kongo - Kinshasa",
  cf: "Srednjoafrička Republika",
  cg: "Kongo - Brazzaville",
  ch: "Švicarska",
  ci: "Obala Bjelokosti",
  ck: "Cookovi Otoci",
  cl: "Čile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Kolumbija",
  cr: "Kostarika",
  cu: "Kuba",
  cv: "Zelenortska Republika",
  cw: "Curaçao",
  cx: "Božićni otok",
  cy: "Cipar",
  cz: "Češka",
  de: "Njemačka",
  dj: "Džibuti",
  dk: "Danska",
  dm: "Dominika",
  do: "Dominikanska Republika",
  dz: "Alžir",
  ec: "Ekvador",
  ee: "Estonija",
  eg: "Egipat",
  eh: "Zapadna Sahara",
  er: "Eritreja",
  es: "Španjolska",
  et: "Etiopija",
  fi: "Finska",
  fj: "Fidži",
  fk: "Falklandski otoci",
  fm: "Mikronezija",
  fo: "Farski otoci",
  fr: "Francuska",
  ga: "Gabon",
  gb: "Ujedinjeno Kraljevstvo",
  gd: "Grenada",
  ge: "Gruzija",
  gf: "Francuska Gijana",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Grenland",
  gm: "Gambija",
  gn: "Gvineja",
  gp: "Guadalupe",
  gq: "Ekvatorska Gvineja",
  gr: "Grčka",
  gt: "Gvatemala",
  gu: "Guam",
  gw: "Gvineja Bisau",
  gy: "Gvajana",
  hk: "PUP Hong Kong Kina",
  hn: "Honduras",
  hr: "Hrvatska",
  ht: "Haiti",
  hu: "Mađarska",
  id: "Indonezija",
  ie: "Irska",
  il: "Izrael",
  im: "Otok Man",
  in: "Indija",
  io: "Britanski Indijskooceanski teritorij",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italija",
  je: "Jersey",
  jm: "Jamajka",
  jo: "Jordan",
  jp: "Japan",
  ke: "Kenija",
  kg: "Kirgistan",
  kh: "Kambodža",
  ki: "Kiribati",
  km: "Komori",
  kn: "Sveti Kristofor i Nevis",
  kp: "Sjeverna Koreja",
  kr: "Južna Koreja",
  kw: "Kuvajt",
  ky: "Kajmanski otoci",
  kz: "Kazahstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Sveta Lucija",
  li: "Lihtenštajn",
  lk: "Šri Lanka",
  lr: "Liberija",
  ls: "Lesoto",
  lt: "Litva",
  lu: "Luksemburg",
  lv: "Latvija",
  ly: "Libija",
  ma: "Maroko",
  mc: "Monako",
  md: "Moldavija",
  me: "Crna Gora",
  mf: "Saint Martin",
  mg: "Madagaskar",
  mh: "Maršalovi Otoci",
  mk: "Sjeverna Makedonija",
  ml: "Mali",
  mm: "Mjanmar (Burma)",
  mn: "Mongolija",
  mo: "PUP Makao Kina",
  mp: "Sjevernomarijanski otoci",
  mq: "Martinique",
  mr: "Mauretanija",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauricijus",
  mv: "Maldivi",
  mw: "Malavi",
  mx: "Meksiko",
  my: "Malezija",
  mz: "Mozambik",
  na: "Namibija",
  nc: "Nova Kaledonija",
  ne: "Niger",
  nf: "Otok Norfolk",
  ng: "Nigerija",
  ni: "Nikaragva",
  nl: "Nizozemska",
  no: "Norveška",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Novi Zeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Francuska Polinezija",
  pg: "Papua Nova Gvineja",
  ph: "Filipini",
  pk: "Pakistan",
  pl: "Poljska",
  pm: "Saint-Pierre-et-Miquelon",
  pr: "Portoriko",
  ps: "Palestinsko područje",
  pt: "Portugal",
  pw: "Palau",
  py: "Paragvaj",
  qa: "Katar",
  re: "Réunion",
  ro: "Rumunjska",
  rs: "Srbija",
  ru: "Rusija",
  rw: "Ruanda",
  sa: "Saudijska Arabija",
  sb: "Salomonski Otoci",
  sc: "Sejšeli",
  sd: "Sudan",
  se: "Švedska",
  sg: "Singapur",
  sh: "Sveta Helena",
  si: "Slovenija",
  sj: "Svalbard i Jan Mayen",
  sk: "Slovačka",
  sl: "Sijera Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalija",
  sr: "Surinam",
  ss: "Južni Sudan",
  st: "Sveti Toma i Princip",
  sv: "Salvador",
  sx: "Sint Maarten",
  sy: "Sirija",
  sz: "Esvatini",
  tc: "Otoci Turks i Caicos",
  td: "Čad",
  tg: "Togo",
  th: "Tajland",
  tj: "Tadžikistan",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turkmenistan",
  tn: "Tunis",
  to: "Tonga",
  tr: "Turska",
  tt: "Trinidad i Tobago",
  tv: "Tuvalu",
  tw: "Tajvan",
  tz: "Tanzanija",
  ua: "Ukrajina",
  ug: "Uganda",
  us: "Sjedinjene Američke Države",
  uy: "Urugvaj",
  uz: "Uzbekistan",
  va: "Vatikanski Grad",
  vc: "Sveti Vincent i Grenadini",
  ve: "Venezuela",
  vg: "Britanski Djevičanski otoci",
  vi: "Američki Djevičanski otoci",
  vn: "Vijetnam",
  vu: "Vanuatu",
  wf: "Wallis i Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Južnoafrička Republika",
  zm: "Zambija",
  zw: "Zimbabve"
}, S = {
  selectedCountryAriaLabel: "Odabrana zemlja",
  noCountrySelected: "Zemlja nije odabrana",
  countryListAriaLabel: "Lista zemalja",
  searchPlaceholder: "Pretraži",
  zeroSearchResults: "Nema pronađenih rezultata",
  oneSearchResult: "Pronađen 1 rezultat",
  multipleSearchResults: "${count} rezultata pronađeno",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, p = { ...h, ...S }, y = {
  ad: "Andorra",
  ae: "Emirati Arabi Uniti",
  af: "Afghanistan",
  ag: "Antigua e Barbuda",
  ai: "Anguilla",
  al: "Albania",
  am: "Armenia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa americane",
  at: "Austria",
  au: "Australia",
  aw: "Aruba",
  ax: "Isole Åland",
  az: "Azerbaigian",
  ba: "Bosnia ed Erzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgio",
  bf: "Burkina Faso",
  bg: "Bulgaria",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caraibi olandesi",
  br: "Brasile",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Bielorussia",
  bz: "Belize",
  ca: "Canada",
  cc: "Isole Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "Repubblica Centrafricana",
  cg: "Congo-Brazzaville",
  ch: "Svizzera",
  ci: "Costa d’Avorio",
  ck: "Isole Cook",
  cl: "Cile",
  cm: "Camerun",
  cn: "Cina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Capo Verde",
  cw: "Curaçao",
  cx: "Isola Christmas",
  cy: "Cipro",
  cz: "Cechia",
  de: "Germania",
  dj: "Gibuti",
  dk: "Danimarca",
  dm: "Dominica",
  do: "Repubblica Dominicana",
  dz: "Algeria",
  ec: "Ecuador",
  ee: "Estonia",
  eg: "Egitto",
  eh: "Sahara occidentale",
  er: "Eritrea",
  es: "Spagna",
  et: "Etiopia",
  fi: "Finlandia",
  fj: "Figi",
  fk: "Isole Falkland",
  fm: "Micronesia",
  fo: "Isole Fær Øer",
  fr: "Francia",
  ga: "Gabon",
  gb: "Regno Unito",
  gd: "Grenada",
  ge: "Georgia",
  gf: "Guyana francese",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibilterra",
  gl: "Groenlandia",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadalupa",
  gq: "Guinea Equatoriale",
  gr: "Grecia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "RAS di Hong Kong",
  hn: "Honduras",
  hr: "Croazia",
  ht: "Haiti",
  hu: "Ungheria",
  id: "Indonesia",
  ie: "Irlanda",
  il: "Israele",
  im: "Isola di Man",
  in: "India",
  io: "Territorio britannico dell’Oceano Indiano",
  iq: "Iraq",
  ir: "Iran",
  is: "Islanda",
  it: "Italia",
  je: "Jersey",
  jm: "Giamaica",
  jo: "Giordania",
  jp: "Giappone",
  ke: "Kenya",
  kg: "Kirghizistan",
  kh: "Cambogia",
  ki: "Kiribati",
  km: "Comore",
  kn: "Saint Kitts e Nevis",
  kp: "Corea del Nord",
  kr: "Corea del Sud",
  kw: "Kuwait",
  ky: "Isole Cayman",
  kz: "Kazakistan",
  la: "Laos",
  lb: "Libano",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Lituania",
  lu: "Lussemburgo",
  lv: "Lettonia",
  ly: "Libia",
  ma: "Marocco",
  mc: "Monaco",
  md: "Moldavia",
  me: "Montenegro",
  mf: "Saint Martin",
  mg: "Madagascar",
  mh: "Isole Marshall",
  mk: "Macedonia del Nord",
  ml: "Mali",
  mm: "Myanmar (Birmania)",
  mn: "Mongolia",
  mo: "RAS di Macao",
  mp: "Isole Marianne settentrionali",
  mq: "Martinica",
  mr: "Mauritania",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldive",
  mw: "Malawi",
  mx: "Messico",
  my: "Malaysia",
  mz: "Mozambico",
  na: "Namibia",
  nc: "Nuova Caledonia",
  ne: "Niger",
  nf: "Isola Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Paesi Bassi",
  no: "Norvegia",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nuova Zelanda",
  om: "Oman",
  pa: "Panamá",
  pe: "Perù",
  pf: "Polinesia francese",
  pg: "Papua Nuova Guinea",
  ph: "Filippine",
  pk: "Pakistan",
  pl: "Polonia",
  pm: "Saint-Pierre e Miquelon",
  pr: "Portorico",
  ps: "Territori palestinesi",
  pt: "Portogallo",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Riunione",
  ro: "Romania",
  rs: "Serbia",
  ru: "Russia",
  rw: "Ruanda",
  sa: "Arabia Saudita",
  sb: "Isole Salomone",
  sc: "Seychelles",
  sd: "Sudan",
  se: "Svezia",
  sg: "Singapore",
  sh: "Sant’Elena",
  si: "Slovenia",
  sj: "Svalbard e Jan Mayen",
  sk: "Slovacchia",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Suriname",
  ss: "Sud Sudan",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Siria",
  sz: "Swaziland",
  tc: "Isole Turks e Caicos",
  td: "Ciad",
  tg: "Togo",
  th: "Thailandia",
  tj: "Tagikistan",
  tk: "Tokelau",
  tl: "Timor Est",
  tm: "Turkmenistan",
  tn: "Tunisia",
  to: "Tonga",
  tr: "Turchia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ucraina",
  ug: "Uganda",
  us: "Stati Uniti",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Città del Vaticano",
  vc: "Saint Vincent e Grenadine",
  ve: "Venezuela",
  vg: "Isole Vergini Britanniche",
  vi: "Isole Vergini Americane",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Yemen",
  yt: "Mayotte",
  za: "Sudafrica",
  zm: "Zambia",
  zw: "Zimbabwe"
}, v = {
  selectedCountryAriaLabel: "Paese selezionato",
  noCountrySelected: "Nessun paese selezionato",
  countryListAriaLabel: "Elenco dei paesi",
  searchPlaceholder: "Ricerca",
  zeroSearchResults: "Nessun risultato trovato",
  oneSearchResult: "1 risultato trovato",
  multipleSearchResults: "${count} risultati trovati",
  // additional countries (not supported by country-list library)
  ac: "Isola di Ascensione",
  xk: "Kosovo"
}, M = { ...y, ...v }, z = {
  ad: "Andorra",
  ae: "Verenigde Arabische Emiraten",
  af: "Afghanistan",
  ag: "Antigua en Barbuda",
  ai: "Anguilla",
  al: "Albanië",
  am: "Armenië",
  ao: "Angola",
  ar: "Argentinië",
  as: "Amerikaans-Samoa",
  at: "Oostenrijk",
  au: "Australië",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbeidzjan",
  ba: "Bosnië en Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "België",
  bf: "Burkina Faso",
  bg: "Bulgarije",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "Saint-Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Caribisch Nederland",
  br: "Brazilië",
  bs: "Bahama’s",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Belarus",
  bz: "Belize",
  ca: "Canada",
  cc: "Cocoseilanden",
  cd: "Congo-Kinshasa",
  cf: "Centraal-Afrikaanse Republiek",
  cg: "Congo-Brazzaville",
  ch: "Zwitserland",
  ci: "Ivoorkust",
  ck: "Cookeilanden",
  cl: "Chili",
  cm: "Kameroen",
  cn: "China",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Kaapverdië",
  cw: "Curaçao",
  cx: "Christmaseiland",
  cy: "Cyprus",
  cz: "Tsjechië",
  de: "Duitsland",
  dj: "Djibouti",
  dk: "Denemarken",
  dm: "Dominica",
  do: "Dominicaanse Republiek",
  dz: "Algerije",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypte",
  eh: "Westelijke Sahara",
  er: "Eritrea",
  es: "Spanje",
  et: "Ethiopië",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandeilanden",
  fm: "Micronesia",
  fo: "Faeröer",
  fr: "Frankrijk",
  ga: "Gabon",
  gb: "Verenigd Koninkrijk",
  gd: "Grenada",
  ge: "Georgië",
  gf: "Frans-Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Groenland",
  gm: "Gambia",
  gn: "Guinee",
  gp: "Guadeloupe",
  gq: "Equatoriaal-Guinea",
  gr: "Griekenland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinee-Bissau",
  gy: "Guyana",
  hk: "Hongkong SAR van China",
  hn: "Honduras",
  hr: "Kroatië",
  ht: "Haïti",
  hu: "Hongarije",
  id: "Indonesië",
  ie: "Ierland",
  il: "Israël",
  im: "Isle of Man",
  in: "India",
  io: "Brits Indische Oceaanterritorium",
  iq: "Irak",
  ir: "Iran",
  is: "IJsland",
  it: "Italië",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanië",
  jp: "Japan",
  ke: "Kenia",
  kg: "Kirgizië",
  kh: "Cambodja",
  ki: "Kiribati",
  km: "Comoren",
  kn: "Saint Kitts en Nevis",
  kp: "Noord-Korea",
  kr: "Zuid-Korea",
  kw: "Koeweit",
  ky: "Kaaimaneilanden",
  kz: "Kazachstan",
  la: "Laos",
  lb: "Libanon",
  lc: "Saint Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litouwen",
  lu: "Luxemburg",
  lv: "Letland",
  ly: "Libië",
  ma: "Marokko",
  mc: "Monaco",
  md: "Moldavië",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshalleilanden",
  mk: "Noord-Macedonië",
  ml: "Mali",
  mm: "Myanmar (Birma)",
  mn: "Mongolië",
  mo: "Macau SAR van China",
  mp: "Noordelijke Marianen",
  mq: "Martinique",
  mr: "Mauritanië",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiven",
  mw: "Malawi",
  mx: "Mexico",
  my: "Maleisië",
  mz: "Mozambique",
  na: "Namibië",
  nc: "Nieuw-Caledonië",
  ne: "Niger",
  nf: "Norfolk",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederland",
  no: "Noorwegen",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nieuw-Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Frans-Polynesië",
  pg: "Papoea-Nieuw-Guinea",
  ph: "Filipijnen",
  pk: "Pakistan",
  pl: "Polen",
  pm: "Saint-Pierre en Miquelon",
  pr: "Puerto Rico",
  ps: "Palestijnse gebieden",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Roemenië",
  rs: "Servië",
  ru: "Rusland",
  rw: "Rwanda",
  sa: "Saoedi-Arabië",
  sb: "Salomonseilanden",
  sc: "Seychellen",
  sd: "Soedan",
  se: "Zweden",
  sg: "Singapore",
  sh: "Sint-Helena",
  si: "Slovenië",
  sj: "Spitsbergen en Jan Mayen",
  sk: "Slowakije",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalië",
  sr: "Suriname",
  ss: "Zuid-Soedan",
  st: "Sao Tomé en Principe",
  sv: "El Salvador",
  sx: "Sint-Maarten",
  sy: "Syrië",
  sz: "eSwatini",
  tc: "Turks- en Caicoseilanden",
  td: "Tsjaad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Oost-Timor",
  tm: "Turkmenistan",
  tn: "Tunesië",
  to: "Tonga",
  tr: "Turkije",
  tt: "Trinidad en Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Oekraïne",
  ug: "Oeganda",
  us: "Verenigde Staten",
  uy: "Uruguay",
  uz: "Oezbekistan",
  va: "Vaticaanstad",
  vc: "Saint Vincent en de Grenadines",
  ve: "Venezuela",
  vg: "Britse Maagdeneilanden",
  vi: "Amerikaanse Maagdeneilanden",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis en Futuna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Zuid-Afrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, B = {
  selectedCountryAriaLabel: "Geselecteerd land",
  noCountrySelected: "Geen land geselecteerd",
  countryListAriaLabel: "Lijst met landen",
  searchPlaceholder: "Zoekopdracht",
  zeroSearchResults: "Geen resultaten gevonden",
  oneSearchResult: "1 resultaat gevonden",
  multipleSearchResults: "${count} resultaten gevonden",
  // additional countries (not supported by country-list library)
  ac: "Ascension-eiland",
  xk: "Kosovo"
}, a = { ...z, ...B }, C = {
  ad: "Andorra",
  ae: "Emirados Árabes Unidos",
  af: "Afeganistão",
  ag: "Antígua e Barbuda",
  ai: "Anguila",
  al: "Albânia",
  am: "Armênia",
  ao: "Angola",
  ar: "Argentina",
  as: "Samoa Americana",
  at: "Áustria",
  au: "Austrália",
  aw: "Aruba",
  ax: "Ilhas Aland",
  az: "Azerbaijão",
  ba: "Bósnia e Herzegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Bélgica",
  bf: "Burquina Faso",
  bg: "Bulgária",
  bh: "Bahrein",
  bi: "Burundi",
  bj: "Benin",
  bl: "São Bartolomeu",
  bm: "Bermudas",
  bn: "Brunei",
  bo: "Bolívia",
  bq: "Países Baixos Caribenhos",
  br: "Brasil",
  bs: "Bahamas",
  bt: "Butão",
  bw: "Botsuana",
  by: "Bielorrússia",
  bz: "Belize",
  ca: "Canadá",
  cc: "Ilhas Cocos (Keeling)",
  cd: "Congo - Kinshasa",
  cf: "República Centro-Africana",
  cg: "República do Congo",
  ch: "Suíça",
  ci: "Costa do Marfim",
  ck: "Ilhas Cook",
  cl: "Chile",
  cm: "Camarões",
  cn: "China",
  co: "Colômbia",
  cr: "Costa Rica",
  cu: "Cuba",
  cv: "Cabo Verde",
  cw: "Curaçao",
  cx: "Ilha Christmas",
  cy: "Chipre",
  cz: "Tchéquia",
  de: "Alemanha",
  dj: "Djibuti",
  dk: "Dinamarca",
  dm: "Dominica",
  do: "República Dominicana",
  dz: "Argélia",
  ec: "Equador",
  ee: "Estônia",
  eg: "Egito",
  eh: "Saara Ocidental",
  er: "Eritreia",
  es: "Espanha",
  et: "Etiópia",
  fi: "Finlândia",
  fj: "Fiji",
  fk: "Ilhas Malvinas",
  fm: "Micronésia",
  fo: "Ilhas Faroe",
  fr: "França",
  ga: "Gabão",
  gb: "Reino Unido",
  gd: "Granada",
  ge: "Geórgia",
  gf: "Guiana Francesa",
  gg: "Guernsey",
  gh: "Gana",
  gi: "Gibraltar",
  gl: "Groenlândia",
  gm: "Gâmbia",
  gn: "Guiné",
  gp: "Guadalupe",
  gq: "Guiné Equatorial",
  gr: "Grécia",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guiné-Bissau",
  gy: "Guiana",
  hk: "Hong Kong, RAE da China",
  hn: "Honduras",
  hr: "Croácia",
  ht: "Haiti",
  hu: "Hungria",
  id: "Indonésia",
  ie: "Irlanda",
  il: "Israel",
  im: "Ilha de Man",
  in: "Índia",
  io: "Território Britânico do Oceano Índico",
  iq: "Iraque",
  ir: "Irã",
  is: "Islândia",
  it: "Itália",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordânia",
  jp: "Japão",
  ke: "Quênia",
  kg: "Quirguistão",
  kh: "Camboja",
  ki: "Quiribati",
  km: "Comores",
  kn: "São Cristóvão e Névis",
  kp: "Coreia do Norte",
  kr: "Coreia do Sul",
  kw: "Kuwait",
  ky: "Ilhas Cayman",
  kz: "Cazaquistão",
  la: "Laos",
  lb: "Líbano",
  lc: "Santa Lúcia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Libéria",
  ls: "Lesoto",
  lt: "Lituânia",
  lu: "Luxemburgo",
  lv: "Letônia",
  ly: "Líbia",
  ma: "Marrocos",
  mc: "Mônaco",
  md: "Moldova",
  me: "Montenegro",
  mf: "São Martinho",
  mg: "Madagascar",
  mh: "Ilhas Marshall",
  mk: "Macedônia do Norte",
  ml: "Mali",
  mm: "Mianmar (Birmânia)",
  mn: "Mongólia",
  mo: "Macau, RAE da China",
  mp: "Ilhas Marianas do Norte",
  mq: "Martinica",
  mr: "Mauritânia",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Maurício",
  mv: "Maldivas",
  mw: "Malaui",
  mx: "México",
  my: "Malásia",
  mz: "Moçambique",
  na: "Namíbia",
  nc: "Nova Caledônia",
  ne: "Níger",
  nf: "Ilha Norfolk",
  ng: "Nigéria",
  ni: "Nicarágua",
  nl: "Países Baixos",
  no: "Noruega",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nova Zelândia",
  om: "Omã",
  pa: "Panamá",
  pe: "Peru",
  pf: "Polinésia Francesa",
  pg: "Papua-Nova Guiné",
  ph: "Filipinas",
  pk: "Paquistão",
  pl: "Polônia",
  pm: "São Pedro e Miquelão",
  pr: "Porto Rico",
  ps: "Territórios palestinos",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguai",
  qa: "Catar",
  re: "Reunião",
  ro: "Romênia",
  rs: "Sérvia",
  ru: "Rússia",
  rw: "Ruanda",
  sa: "Arábia Saudita",
  sb: "Ilhas Salomão",
  sc: "Seicheles",
  sd: "Sudão",
  se: "Suécia",
  sg: "Singapura",
  sh: "Santa Helena",
  si: "Eslovênia",
  sj: "Svalbard e Jan Mayen",
  sk: "Eslováquia",
  sl: "Serra Leoa",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somália",
  sr: "Suriname",
  ss: "Sudão do Sul",
  st: "São Tomé e Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Síria",
  sz: "Essuatíni",
  tc: "Ilhas Turcas e Caicos",
  td: "Chade",
  tg: "Togo",
  th: "Tailândia",
  tj: "Tadjiquistão",
  tk: "Tokelau",
  tl: "Timor-Leste",
  tm: "Turcomenistão",
  tn: "Tunísia",
  to: "Tonga",
  tr: "Turquia",
  tt: "Trinidad e Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzânia",
  ua: "Ucrânia",
  ug: "Uganda",
  us: "Estados Unidos",
  uy: "Uruguai",
  uz: "Uzbequistão",
  va: "Cidade do Vaticano",
  vc: "São Vicente e Granadinas",
  ve: "Venezuela",
  vg: "Ilhas Virgens Britânicas",
  vi: "Ilhas Virgens Americanas",
  vn: "Vietnã",
  vu: "Vanuatu",
  wf: "Wallis e Futuna",
  ws: "Samoa",
  ye: "Iêmen",
  yt: "Mayotte",
  za: "África do Sul",
  zm: "Zâmbia",
  zw: "Zimbábue"
}, j = {
  selectedCountryAriaLabel: "País selecionado",
  noCountrySelected: "Nenhum país selecionado",
  countryListAriaLabel: "Lista de países",
  searchPlaceholder: "Procurar",
  zeroSearchResults: "Nenhum resultado encontrado",
  oneSearchResult: "1 resultado encontrado",
  multipleSearchResults: "${count} resultados encontrados",
  // additional countries (not supported by country-list library)
  ac: "Ilha de Ascensão",
  xk: "Kosovo"
}, A = { ...C, ...j }, T = {
  ad: "Andorra",
  ae: "Förenade Arabemiraten",
  af: "Afghanistan",
  ag: "Antigua och Barbuda",
  ai: "Anguilla",
  al: "Albanien",
  am: "Armenien",
  ao: "Angola",
  ar: "Argentina",
  as: "Amerikanska Samoa",
  at: "Österrike",
  au: "Australien",
  aw: "Aruba",
  ax: "Åland",
  az: "Azerbajdzjan",
  ba: "Bosnien och Hercegovina",
  bb: "Barbados",
  bd: "Bangladesh",
  be: "Belgien",
  bf: "Burkina Faso",
  bg: "Bulgarien",
  bh: "Bahrain",
  bi: "Burundi",
  bj: "Benin",
  bl: "S:t Barthélemy",
  bm: "Bermuda",
  bn: "Brunei",
  bo: "Bolivia",
  bq: "Karibiska Nederländerna",
  br: "Brasilien",
  bs: "Bahamas",
  bt: "Bhutan",
  bw: "Botswana",
  by: "Vitryssland",
  bz: "Belize",
  ca: "Kanada",
  cc: "Kokosöarna",
  cd: "Kongo-Kinshasa",
  cf: "Centralafrikanska republiken",
  cg: "Kongo-Brazzaville",
  ch: "Schweiz",
  ci: "Côte d’Ivoire",
  ck: "Cooköarna",
  cl: "Chile",
  cm: "Kamerun",
  cn: "Kina",
  co: "Colombia",
  cr: "Costa Rica",
  cu: "Kuba",
  cv: "Kap Verde",
  cw: "Curaçao",
  cx: "Julön",
  cy: "Cypern",
  cz: "Tjeckien",
  de: "Tyskland",
  dj: "Djibouti",
  dk: "Danmark",
  dm: "Dominica",
  do: "Dominikanska republiken",
  dz: "Algeriet",
  ec: "Ecuador",
  ee: "Estland",
  eg: "Egypten",
  eh: "Västsahara",
  er: "Eritrea",
  es: "Spanien",
  et: "Etiopien",
  fi: "Finland",
  fj: "Fiji",
  fk: "Falklandsöarna",
  fm: "Mikronesien",
  fo: "Färöarna",
  fr: "Frankrike",
  ga: "Gabon",
  gb: "Storbritannien",
  gd: "Grenada",
  ge: "Georgien",
  gf: "Franska Guyana",
  gg: "Guernsey",
  gh: "Ghana",
  gi: "Gibraltar",
  gl: "Grönland",
  gm: "Gambia",
  gn: "Guinea",
  gp: "Guadeloupe",
  gq: "Ekvatorialguinea",
  gr: "Grekland",
  gt: "Guatemala",
  gu: "Guam",
  gw: "Guinea-Bissau",
  gy: "Guyana",
  hk: "Hongkong",
  hn: "Honduras",
  hr: "Kroatien",
  ht: "Haiti",
  hu: "Ungern",
  id: "Indonesien",
  ie: "Irland",
  il: "Israel",
  im: "Isle of Man",
  in: "Indien",
  io: "Brittiska territoriet i Indiska oceanen",
  iq: "Irak",
  ir: "Iran",
  is: "Island",
  it: "Italien",
  je: "Jersey",
  jm: "Jamaica",
  jo: "Jordanien",
  jp: "Japan",
  ke: "Kenya",
  kg: "Kirgizistan",
  kh: "Kambodja",
  ki: "Kiribati",
  km: "Komorerna",
  kn: "S:t Kitts och Nevis",
  kp: "Nordkorea",
  kr: "Sydkorea",
  kw: "Kuwait",
  ky: "Caymanöarna",
  kz: "Kazakstan",
  la: "Laos",
  lb: "Libanon",
  lc: "S:t Lucia",
  li: "Liechtenstein",
  lk: "Sri Lanka",
  lr: "Liberia",
  ls: "Lesotho",
  lt: "Litauen",
  lu: "Luxemburg",
  lv: "Lettland",
  ly: "Libyen",
  ma: "Marocko",
  mc: "Monaco",
  md: "Moldavien",
  me: "Montenegro",
  mf: "Saint-Martin",
  mg: "Madagaskar",
  mh: "Marshallöarna",
  mk: "Nordmakedonien",
  ml: "Mali",
  mm: "Myanmar (Burma)",
  mn: "Mongoliet",
  mo: "Macao",
  mp: "Nordmarianerna",
  mq: "Martinique",
  mr: "Mauretanien",
  ms: "Montserrat",
  mt: "Malta",
  mu: "Mauritius",
  mv: "Maldiverna",
  mw: "Malawi",
  mx: "Mexiko",
  my: "Malaysia",
  mz: "Moçambique",
  na: "Namibia",
  nc: "Nya Kaledonien",
  ne: "Niger",
  nf: "Norfolkön",
  ng: "Nigeria",
  ni: "Nicaragua",
  nl: "Nederländerna",
  no: "Norge",
  np: "Nepal",
  nr: "Nauru",
  nu: "Niue",
  nz: "Nya Zeeland",
  om: "Oman",
  pa: "Panama",
  pe: "Peru",
  pf: "Franska Polynesien",
  pg: "Papua Nya Guinea",
  ph: "Filippinerna",
  pk: "Pakistan",
  pl: "Polen",
  pm: "S:t Pierre och Miquelon",
  pr: "Puerto Rico",
  ps: "Palestinska territorierna",
  pt: "Portugal",
  pw: "Palau",
  py: "Paraguay",
  qa: "Qatar",
  re: "Réunion",
  ro: "Rumänien",
  rs: "Serbien",
  ru: "Ryssland",
  rw: "Rwanda",
  sa: "Saudiarabien",
  sb: "Salomonöarna",
  sc: "Seychellerna",
  sd: "Sudan",
  se: "Sverige",
  sg: "Singapore",
  sh: "S:t Helena",
  si: "Slovenien",
  sj: "Svalbard och Jan Mayen",
  sk: "Slovakien",
  sl: "Sierra Leone",
  sm: "San Marino",
  sn: "Senegal",
  so: "Somalia",
  sr: "Surinam",
  ss: "Sydsudan",
  st: "São Tomé och Príncipe",
  sv: "El Salvador",
  sx: "Sint Maarten",
  sy: "Syrien",
  sz: "Swaziland",
  tc: "Turks- och Caicosöarna",
  td: "Tchad",
  tg: "Togo",
  th: "Thailand",
  tj: "Tadzjikistan",
  tk: "Tokelau",
  tl: "Östtimor",
  tm: "Turkmenistan",
  tn: "Tunisien",
  to: "Tonga",
  tr: "Turkiet",
  tt: "Trinidad och Tobago",
  tv: "Tuvalu",
  tw: "Taiwan",
  tz: "Tanzania",
  ua: "Ukraina",
  ug: "Uganda",
  us: "USA",
  uy: "Uruguay",
  uz: "Uzbekistan",
  va: "Vatikanstaten",
  vc: "S:t Vincent och Grenadinerna",
  ve: "Venezuela",
  vg: "Brittiska Jungfruöarna",
  vi: "Amerikanska Jungfruöarna",
  vn: "Vietnam",
  vu: "Vanuatu",
  wf: "Wallis- och Futunaöarna",
  ws: "Samoa",
  ye: "Jemen",
  yt: "Mayotte",
  za: "Sydafrika",
  zm: "Zambia",
  zw: "Zimbabwe"
}, f = {
  selectedCountryAriaLabel: "Valt land",
  noCountrySelected: "Inget land valt",
  countryListAriaLabel: "Lista över länder",
  searchPlaceholder: "Sök",
  zeroSearchResults: "Inga resultat hittades",
  oneSearchResult: "1 resultat hittades",
  multipleSearchResults: "${count} resultat hittades",
  // additional countries (not supported by country-list library)
  ac: "Ascension",
  xk: "Kosovo"
}, w = { ...T, ...f }, G = {
  en: u,
  fr: k,
  it: M,
  es: m,
  de: s,
  da: i,
  hr: p,
  nb: a,
  nl: a,
  pt: A,
  sv: w
}, N = {
  error: "is-error"
}, L = {
  error: {
    name: "error-warning-fill",
    color: "error"
  }
};
export {
  L as ICONS_STATUS,
  N as INPUT_STATUS,
  G as LOCALES
};
